import "./App.css";
import AppRoutes from "./AppRoutes";
import { ErrorBoundary } from "react-error-boundary";
import InternalServer from "./Pages/Others/InternalServer";
import FormDataContext, { FormDataContextProvider } from "./Contexts/FormData.context";
import SignupDataContext, { UserDataContextProvider } from "./Contexts/User.context";
import { BillingDataContextProvider } from "./Contexts/Billing.Context";
import { getVisitorServiceUrl } from "./Services/base-url/api-constants";
import { Helmet } from "react-helmet";
import $ from "jquery";
import worksimpliFavicon from "./worksimpli-favicon.png";
import LegalSimpliFavIcon from "./legalsimpli-favicon.png";
import { useEffect, useState } from "react";
import { DomainName } from "./Util/Constants";
import Favicon from "react-favicon";

import { currentDomain } from "./Util/general-config";

function App() {
  const url = getVisitorServiceUrl("");
  window.$ = $;
  window.jQuery = $;
  let domain = currentDomain().toLowerCase();
  const [faviconUrl, setFaviconUrl] = useState("");
  useEffect(() => {
    const tempContainer = document.querySelector(".signup_section");
    const footerAlign = document.querySelector("#minimal-footer");

    if (tempContainer && footerAlign) {
      (footerAlign as HTMLElement).style.position = "relative";
    }

    const domainKey = domain;
    const favicons: Record<string, string> = {
      [DomainName.LEGALSIMPLI]: LegalSimpliFavIcon,
      [DomainName.WORKSIMPLI]: worksimpliFavicon,
    };

    if (favicons[domainKey]) {
      setFaviconUrl(favicons[domainKey]);
    }
  }, [domain]);
  return (
    <ErrorBoundary
      FallbackComponent={InternalServer}
      onError={(error, errorInfo) => ({ error, errorInfo })}
      onReset={() => {
        // reset the state of your app
      }}
    >
      <Favicon url={faviconUrl} />
      <Helmet>
        <script src={url} type="text/javascript" />
      </Helmet>
      <UserDataContextProvider>
        <FormDataContextProvider>
          <BillingDataContextProvider>
            <AppRoutes />
          </BillingDataContextProvider>
        </FormDataContextProvider>
      </UserDataContextProvider>

      {/* <SignupDataContextProvider>
            <SignupDataContext.Consumer>{(context) => <AppRoutes />}</SignupDataContext.Consumer>
            </SignupDataContextProvider> */}
    </ErrorBoundary>
  );
}

export default App;
